export const AD_EVENT_TEMPLATE_LOADED = '[AdEngine] Template loaded';
export const AD_EVENT_SLOT_ADDED = '[AdEngine] Ad Slot added';
export const AD_EVENT_SLOT_LOADED = '[AdEngine] Ad Slot loaded';
export const AD_EVENT_UAP_LOAD_STATUS = '[AdEngine] UAP Load status';
export const AD_EVENT_AD_CLICKED = '[AdEngine] Ad clicked';
export const AD_ENGINE_BAB_DETECTION = '[AdEngine] BAB detection finished';
